export const creditAdjustmentCategory = [
    {
        name: 'CHARGEBACK REVERSAL',
        value: 'CHARGEBACK_REVERSAL',
    },
    {
        name: 'INCORRECT MDR',
        value: 'INCORRECT_MDR',
    },
    {
        name: 'FAILED SETTLEMENT',
        value: 'FAILED_SETTLEMENT',
    },
    {
        name: 'OTHERS',
        value: 'OTHERS',
    },
];

export const debitAdjustmentCategory = [
    {
        name: 'CHARGEBACK',
        value: 'CHARGEBACK',
    },
    {
        name: 'INCORRECT MDR',
        value: 'INCORRECT_MDR',
    },
    {
        name: 'MANUAL REFUND',
        value: 'MANUAL_REFUND',
    },
    {
        name: 'OTHERS',
        value: 'OTHERS',
    },
];
